exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simple-trust-banner[data-v-a9a38a98] {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-base);\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.simple-trust-banner__item[data-v-a9a38a98] {\n  align-items: center;\n  display: flex;\n  gap: var(--size-md);\n}\n.simple-trust-banner__item svg[data-v-a9a38a98] {\n  width: var(--size-xl);\n}\n.simple-trust-banner__item span[data-v-a9a38a98] {\n  color: var(--gray-600);\n  font-size: var(--size-base);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  line-height: 1;\n}", ""]);

// exports
